import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  design: defineAsyncComponent(() => import("/app/layouts/design.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/layouts/login.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/app/layouts/print.vue").then(m => m.default || m)),
  testbed: defineAsyncComponent(() => import("/app/layouts/testbed.vue").then(m => m.default || m))
}